import React, { createContext, useState, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import HelpCenterModal from '../HelpCenterModal';

export const HelpCenterContext = createContext();

export const useHelpCenter = () => {
  const context = useContext(HelpCenterContext);
  if (!context) {
    throw new Error('useHelpCenter debe usarse dentro de HelpCenterProvider');
  }
  return context;
};

export const HelpCenterProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Toggle: si está abierto, cerrar; si está cerrado, abrir
  const openHelpCenter = () => setIsOpen(prev => !prev);
  const closeHelpCenter = () => setIsOpen(false);

  // Cerrar el panel de soporte al cambiar de módulo (Dashboard, Campañas, Objetivos, etc.)
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  return (
    <HelpCenterContext.Provider value={{ openHelpCenter, closeHelpCenter }}>
      {children}
      <HelpCenterModal isOpen={isOpen} onClose={closeHelpCenter} />
    </HelpCenterContext.Provider>
  );
};

HelpCenterProvider.propTypes = {
  children: PropTypes.node.isRequired
};
